<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <!-- <button
            class="btn btn-primary mr-1"
            @click="adddebitur()"
            v-b-tooltip.hover
            title="input data baru"
          >
            <i class="fa fa-file"></i> Add
          </button> -->
          
          <!-- <button
            class="btn btn-primary mr-1"
            @click="editdebitur()"
            v-b-tooltip.hover
            title="Revisi/view data"
          >
            <i class="fa fa-pencil"></i> Edit
          </button> -->

          <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="editdebitur()">Edit</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="collectorhistory()">Collector History</b-dropdown-item>
          </b-dropdown>

          <!-- <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="revisipinjaman">Revisi</b-dropdown-item>
            <b-dropdown-item
              @click="angsuran"
              :disabled="(model.model_pinjaman=='PRK')"
            >Jadwal Angsuran</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="harianDtl">Detail Denda/Bunga RK</b-dropdown-item>
            <b-dropdown-item @click="collectionDtl">Collection Activity</b-dropdown-item>
            <b-dropdown-item @click="pelunasan" :disabled="(model.final==1)">Permohonan Pelunasan</b-dropdown-item>
            <b-dropdown-item
              @click="paymentHistory"
              :disabled="(model.final==1)"
            >History Payment & Settlement</b-dropdown-item>
          </b-dropdown> -->

          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i> Filter
          </button>
          <!-- <b-button variant="primary mr-1" @click="showUploadFrm=true"><i class="fa fa-cloud-upload"></i> Import Kolektor pd Debitur</b-button> -->
          <b-button variant="primary mr-1" @click="importCollectorToDebiturXls()"><i class="fa fa-cloud-upload"></i> Import Kolektor pd Debitur</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
          <!-- <b-button variant="primary mr-1" @click="importxls()"><i class="fa fa-cloud-upload"></i> Import</b-button> -->
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.custinfo" placeholder=""></b-form-input>
            <b-input-group-append>
              <label class="ml-1 mr-1">No. Identitas</label>
            </b-input-group-append>
            <b-form-input v-model="tblData.nomoridentitas" placeholder=""></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.alamatktp" placeholder=""></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          
          <!-- <b-input-group>
            <b-input-group-prepend>
              <label>Status</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.status" :options="dataList.debiturStatus"></b-form-select>
          </b-input-group> -->

          <b-input-group>
            <b-input-group-prepend>
              <label>NPWP</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.npwp" placeholder=""></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Nama Kolektor</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.collector_name"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(index)="data">{{ ((tblData.page-1)*tblData.limit) + (data.index + 1) }}</template>
        <!-- <template v-slot:cell(custinfo)="data">{{data.item.CustCode}} | {{data.item.CustName}}</template> -->
        <template v-slot:cell(tgllahir)="data">{{ data.item.tgllahir | moment("DD/MM/YY") }}</template>
        <template v-slot:cell(modified)="data">{{ data.item.modified | moment("DD/MM/YY") }}</template>

        <template v-slot:cell(marital_status)="data">
          <span v-if="data.item.marital_status=='MAR'">Married</span>
          <span v-else-if="data.item.marital_status=='SIN'">Single</span>
          <span v-else-if="data.item.marital_status=='DIV'">Divorce</span>
          <span v-else-if="data.item.marital_status=='WID'">Widow</span>
        </template>

        <template v-slot:cell(jnskelamin)="data">
          <span v-if="data.item.jnskelamin=='M'">Male</span>
          <span v-else-if="data.item.jnskelamin=='F'">Female</span>
        </template>

        <template v-slot:cell(cust_model_code)="data">
          <span v-if="data.item.cust_model_code=='PROF'">Professional</span>
          <span v-else-if="data.item.cust_model_code=='EMP'">Employee</span>
        </template>

        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width:80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <!-- <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal
        v-model="showPostingConfirm"
        title="Posting Record?"
        :centered="true"
        @ok="postingData"
      >
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">
          You can unpost as long as
          <strong>Accounting Periode</strong> stil open
        </p>
      </b-modal>
      <b-modal
        v-model="showUnpostConfirm"
        title="Un Posting Record?"
        :centered="true"
        @ok="unpostData"
      >
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">
          Data Journal will be removed from
          <strong>Accounting</strong>
        </p>
      </b-modal>-->
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import invout from "../../apis/logistic_inv_out";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
// import customer from "../../apis/customer";
import debitur from "../../apis/debitur";
toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      model: {},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        custinfo: "",
        nomoridentitas: "",
        PhoneNo: "",
        alamatktp: "",
        npwp: "",
        City: "",
        collector_name: "",
        modified: "",
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "CustCode",
        sortDesc: false,
        status: "", 
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus
      }, 
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "CustCode",
          label: "CIF",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "salutation",
          label: "Salutation",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "CustName",
          label: "Nama Debitur",
          thClass: "text-center",
          thStyle: "min-width:250px",
          sortable: true
        },
        {
          key: "npwp",
          label: "No. NPWP",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "tmptlahir",
          label: "Tempat Lahir",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "tgllahir",
          label: "Tanggal Lahir",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "nomoridentitas",
          label: "Nomor Identitas",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "kewarganegaraan",
          label: "Kewarganegaraan",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "marital_status",
          label: "Status Perkawinan",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true
        },
        {
          key: "jnskelamin",
          label: "Jenis Kelamin",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "nohandphone",
          label: "Phone Number",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "email",
          label: "Email",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "religion",
          label: "Agama",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "namaibu",
          label: "Ibu Kandung",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "alamatktp",
          label: "Alamat KTP",
          thClass: "text-center",
          thStyle: "min-width:250px",
          sortable: true
        },
        {
          key: "rtktp",
          label: "RT KTP",
          thClass: "text-center",
          thStyle: "min-width:80px",
          sortable: true
        },
        {
          key: "rwktp",
          label: "RW KTP",
          thClass: "text-center",
          thStyle: "min-width:80px",
          sortable: true
        },
        {
          key: "kelurahanktp",
          label: "Kelurahan KTP",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true
        },
        {
          key: "kecamatanktp",
          label: "Kecamatan KTP",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true
        },
        {
          key: "kotaktp",
          label: "Kota KTP",
          thClass: "text-center",
          thStyle: "min-width:200px",
          sortable: true
        },
        {
          key: "provinsiktp",
          label: "Provinsi KTP",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "kodeposktp",
          label: "Kodepos KTP",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },

        {
          key: "alamat",
          label: "Alamat Tinggal",
          thClass: "text-center",
          thStyle: "min-width:250px",
          sortable: true
        },
        {
          key: "rt",
          label: "RT Tinggal",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "rw",
          label: "RW Tinggal",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "kelurahan",
          label: "Kelurahan Tinggal",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true
        },
        {
          key: "kecamatan",
          label: "Kecamatan Tinggal",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true
        },
        {
          key: "kota",
          label: "Kota Tinggal",
          thClass: "text-center",
          thStyle: "min-width:200px",
          sortable: true
        },
        {
          key: "provinsi",
          label: "Provinsi Tinggal",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "kodepos",
          label: "Kodepos Tinggal",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true
        },
        {
          key: "phone_area",
          label: "Phone Area",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "cust_model_code",
          label: "Debitur Model",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true
        },
        {
          key: "prefession_code",
          label: "Profession",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "coy_name",
          label: "Coy Name",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true
        },
        {
          key: "coy_scale",
          label: "Coy Scale",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "collector_name",
          label: "Kolektor Name",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "modified_by",
          label: "Modified By",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "modified",
          label: "Modified Date",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "createby",
          label: "Created By",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        }
      ];
      return fields;
    },
  },
  methods: {
    async adddebitur() {
      router.push({ name: "loan.master-debitur-form" });
    },
    async editdebitur() {
        if (this.model.nasabahkey && this.model.nasabahkey !== "undefined") {
          const filter = this.$store.state.filter;
          filter.debiturList=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name :'loan.master-debitur-form', params: { nasabahkey: this.model.nasabahkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },

    async collectorhistory() {
      if (this.model.nasabahkey) {
        router.push({
          name: "loan.history-collector-to-debitur",
          params: { nasabahkey: this.model.nasabahkey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },

    rowClicked(record, index) {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },    
    async data() {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.debiturList) {
            this.tblData[key] = filter.debiturList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await debitur.list(this.tblData);
      return list;
    },
    async exportxls() {
      try {
        //console.log("#this.tblData: ", this.tblData);
        await debitur.exportxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    // async importxls() {
    //   router.push({ name :'loan.importdatadebitur' });
    // },
    async importCollectorToDebiturXls() {
      router.push({ name :'loan.importDataCollectorToDebitur' });
    },

    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.custinfo = "";
      this.tblData.nomoridentitas = "";
      this.tblData.alamatktp = "";
      this.tblData.npwp = "";
      this.tblData.collector_name = "";
      this.refresh();
    },

    close() {
      router.push({ name: "loan.home" });
    }
  }
};
</script>
      
      <style>
</style>